import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import CreateConversation from '@/graphql/chat/mutations/create-conversation.mutation'
import CreateMessage from '@/graphql/chat/mutations/create-message.mutation'
import UpdateConversation from '@/graphql/chat/mutations/update-conversation.mutation'
import axios from 'axios'
import uuid from 'uuid/v4'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
const slackUrl = 'https://hooks.slack.com/services/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'
const Validator = require('validatorjs')
Validator.useLang('ja')

export default {
  name: 'scout',
  components: {
    SharedHeader,
    SharedFooter,
    Datepicker
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    },
    env () {
      return this.$store.getters.env
    }
  },
  data () {
    return {
      loading: false,
      intern: {
        want: '',
        title: '',
        skill: [],
        workableTime: {
          mon: {},
          tue: {},
          wed: {},
          tus: {},
          fri: {},
          sat: {},
          sun: {}
        }
      },
      student: {},
      scout: {
        company: '',
        want: '',
        fee: '',
        fare: '',
        workableTime: {
          mon: {},
          tue: {},
          wed: {},
          tus: {},
          fri: {},
          sat: {},
          sun: {}
        },
        startDate: '',
        interviewDates: [{}, {}, {}]
      },
      select: {
        startDate: '',
        interviewDates: [
          { date: '', hour: '', minute: '' },
          { date: '', hour: '', minute: '' },
          { date: '', hour: '', minute: '' }
        ]
      },
      isWorkableTimeAfter: false,
      isStartDateAfter: false,
      isInterviewDatesAfter: false,
      updating: false,
      error: {},
      isAlert: false,
      state: {},
      fields: [
        { key: 'time', label: '', class: 'text-primary font-weight-bold' },
        { key: 'mon', label: '月' },
        { key: 'tue', label: '火' },
        { key: 'wed', label: '水' },
        { key: 'tus', label: '木' },
        { key: 'fri', label: '金' },
        { key: 'sat', label: '土' },
        { key: 'sun', label: '日' }
      ],
      items: [
        { time: { label: '9:00 〜 12:00', value: 1 } },
        { time: { label: '12:00 〜 15:00', value: 2 } },
        { time: { label: '15:00 〜 18:00', value: 3 } },
        { time: { label: '18:00 〜 21:00', value: 4 } }
      ],
      fareOptions: [
        { text: '支給あり', value: 1 },
        { text: '支給なし', value: 2 }
      ],
      isModal: false,
      ja: ja,
      hoursOption: [
        { value: '', text: '時' }, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21
      ],
      minutesOption: [ { value: '', text: '分' }, '00', '15', '30', '45' ]
    }
  },
  mounted () {
    this.loading = true

    let pathParams = {
      internId: this.$route.params.internId
    }

    let additionalParams = {
      queryParams: {
        type: 'detail'
      }
    }

    this.$apig.get(this.api.INTERN, pathParams, additionalParams, {})
      .then(response => {
        this.intern = response.data.intern
        this.student = response.data.student

        for (let key in response.data.intern.workableTime) {
          if (response.data.intern.workableTime[key]) {
            for (let subKey in response.data.intern.workableTime[key]) {
              if (response.data.intern.workableTime[key][subKey]) {
                // console.log(`key: ${key}, subKey: ${subKey}`)
                if (!this.items[Number(subKey) - 1]['_cellVariants']) this.items[Number(subKey) - 1]['_cellVariants'] = {}
                this.items[Number(subKey) - 1]['_cellVariants'][key] = 'success'
              }
            }
          }
        }

        this.loading = false
      })
  },
  methods: {
    openScoutModal () {
      let allState = true
      this.setCompanyState()
      this.setWantState()
      this.setFeeState()
      this.setFareState()
      this.setWorkableTimeState()
      this.setStartDateState()
      this.setInterViewDateState()

      for (let key in this.state) {
        if (allState) allState = this.state[key]
      }

      if (!allState) {
        this.error.message = '必須項目を入力してください'
        this.isAlert = true
        window.scrollTo(0, 0)
        this.updating = false
      } else {
        this.isAlert = false
        this.isModal = true
      }
    },
    sendScout () {
      this.updating = true
      let allState = true
      this.setCompanyState()
      this.setWantState()
      this.setFeeState()
      this.setFareState()
      this.setWorkableTimeState()
      this.setStartDateState()
      this.setInterViewDateState()

      for (let key in this.state) {
        if (allState) allState = this.state[key]
      }

      if (!allState) {
        this.error.message = '必須項目を入力してください'
        this.isAlert = true
        window.scrollTo(0, 0)
        this.updating = false
        this.isModal = false
      } else {
        this.isAlert = false

        let pathParams = {
          internId: this.$route.params.internId
        }

        let additionalParams = {
          queryParams: {
            type: 'scout'
          }
        }

        let body = this.scout
        let conversationId = uuid()
        body.conversationId = conversationId

        if (this.isWorkableTimeAfter) delete body.workableTime
        if (this.isStartDateAfter) delete body.startDate
        if (this.isInterviewDatesAfter) delete body.interviewDates

        this.$apig.patch(this.api.INTERN, pathParams, additionalParams, body)
          .then(response => {
            this.createConversation(conversationId, this.$route.params.internId, this.student.studentId, this.intern.title)
              .then(() => {
                let content = `${this.user.name}さんからスカウトが届きました。\n\n` +
                  `【会社概要】\n` +
                  `${this.scout.company}\n\n` +
                  `【やってほしいこと】\n` +
                  `${this.scout.want}\n\n` +
                  `さらに詳しい内容を右上の「スカウト内容」から確認しましょう！\n` +
                  `スカウトの話を詳しく聞いてみたい場合は「承認」を押してメッセージで面談日を決めましょう。`
                this.sendMessage(conversationId, content)
                  .then(messageId => {
                    let room = {
                      id: conversationId,
                      user: {
                        id: this.user.enterpriseId,
                        name: this.user.name
                      },
                      opponent: {
                        id: this.student.studentId,
                        name: this.student.nickname
                      },
                      title: this.intern.title
                    }
                    let message = {
                      id: messageId,
                      content
                    }
                    this.sendSlackHook(room, message)
                    this.$router.push(`/chat?id=${conversationId}`)
                  })
              })
          })
          .catch(err => {
            console.log(err)
            this.error = err.response.data
            this.isAlert = true
            window.scrollTo(0, 0)
            this.updating.confirm = false
          })
      }
    },
    setCompanyState () {
      let v = new Validator({
        '会社概要': this.scout.company
      }, {
        '会社概要': 'required|max:140'
      })

      let pass = v.passes()
      this.error.company = v.errors.first('会社概要')

      this.state.company = pass
    },
    setWantState () {
      let v = new Validator({
        'やってほしいこと': this.scout.want
      }, {
        'やってほしいこと': 'required'
      })

      let pass = v.passes()
      this.error.want = v.errors.first('やってほしいこと')

      this.state.want = pass
    },
    setFeeState () {
      let v = new Validator({
        '給与': this.scout.fee
      }, {
        '給与': 'required|numeric|min:1000'
      })

      let pass = v.passes()
      this.error.fee = v.errors.first('給与')

      this.state.fee = pass
    },
    setFareState () {
      let v = new Validator({
        '交通費': this.scout.fare
      }, {
        '交通費': 'required'
      })

      let pass = v.passes()
      this.error.fare = v.errors.first('交通費')

      this.state.fare = pass
    },
    setWorkableTimeState () {
      if (this.isWorkableTimeAfter) {
        this.state.workableTime = true
        this.scout.workableTime = {
          mon: {},
          tue: {},
          wed: {},
          tus: {},
          fri: {},
          sat: {},
          sun: {}
        }
      } else if (!Object.keys(this.scout.workableTime.mon).length &&
        !Object.keys(this.scout.workableTime.tue).length &&
        !Object.keys(this.scout.workableTime.wed).length &&
        !Object.keys(this.scout.workableTime.tus).length &&
        !Object.keys(this.scout.workableTime.fri).length &&
        !Object.keys(this.scout.workableTime.sat).length &&
        !Object.keys(this.scout.workableTime.sun).length
      ) {
        this.state.workableTime = false
        this.error.workableTime = '勤務スケジュールは必須です。'
      } else {
        this.state.workableTime = true
      }
    },
    setStartDateState () {
      if (this.isStartDateAfter) {
        this.state.startDate = true
        this.scout.startDate = ''
        this.select.startDate = ''
      } else {
        let v = new Validator({
          'インターン開始予定日': this.select.startDate
        }, {
          'インターン開始予定日': 'required'
        })

        let pass = v.passes()
        this.error.startDate = v.errors.first('インターン開始予定日')

        this.state.startDate = pass

        if (pass) {
          let dt = new Date(this.select.startDate)
          this.scout.startDate = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()}`
        }
      }
    },
    setInterViewDateState () {
      if (this.isInterviewDatesAfter) {
        this.state.interviewDates = true
        this.scout.interviewDates = [{}, {}, {}]
        this.select.interviewDates = [
          { date: '', hour: '', minute: '' },
          { date: '', hour: '', minute: '' },
          { date: '', hour: '', minute: '' }
        ]
      } else {
        let v = new Validator({
          '面談希望日程': this.select.interviewDates[0].date,
          '時': this.select.interviewDates[0].hour,
          '分': this.select.interviewDates[0].minute
        }, {
          '面談希望日程': 'required',
          '時': 'required',
          '分': 'required'
        })

        let pass = v.passes()
        this.error.interviewDates = v.errors.first('面談希望日程') ? v.errors.first('面談希望日程') : v.errors.first('時')

        this.state.interviewDates = pass

        if (pass) {
          let dt = new Date(this.select.interviewDates[0].date)
          this.scout.interviewDates[0].date = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()}`
          this.scout.interviewDates[0].time = `${this.select.interviewDates[0].hour}:${this.select.interviewDates[0].minute}`

          if (this.select.interviewDates[1].date && this.select.interviewDates[1].hour && this.select.interviewDates[1].time) {
            dt = new Date(this.select.interviewDates[1].date)
            this.scout.interviewDates[1].date = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()}`
            this.scout.interviewDates[1].time = `${this.select.interviewDates[1].hour}:${this.select.interviewDates[1].minute}`
          }

          if (this.select.interviewDates[2].date && this.select.interviewDates[2].hour && this.select.interviewDates[2].time) {
            dt = new Date(this.select.interviewDates[2].date)
            this.scout.interviewDates[2].date = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()}`
            this.scout.interviewDates[2].time = `${this.select.interviewDates[2].hour}:${this.select.interviewDates[2].minute}`
          }
        }
      }
    },
    getAvatar (avatarId) {
      return `${process.env.S3}/student/avatar/${avatarId}.png`
    },
    async createConversation (conversationId, internId, opponentId, title) {
      let updatedAt = new Date()
      let id = conversationId

      await this.$apollo.mutate({
        mutation: CreateConversation,
        variables: {
          input: {
            id,
            userId: this.user.enterpriseId,
            userType: 'ENTERPRISE',
            opponentId,
            opponentType: 'STUDENT',
            updatedAt,
            title,
            internId
          }
        }
      })

      await this.$apollo.mutate({
        mutation: CreateConversation,
        variables: {
          input: {
            id,
            userId: opponentId,
            userType: 'STUDENT',
            opponentId: this.user.enterpriseId,
            opponentType: 'ENTERPRISE',
            updatedAt,
            title,
            internId
          }
        }
      })
    },
    async sendMessage (conversationId, content) {
      const messageResponce = await this.$apollo.mutate({
        mutation: CreateMessage,
        variables: {
          input: {
            ownerId: this.user.enterpriseId,
            opponentId: this.student.studentId,
            conversationId,
            ownerType: 'ENTERPRISE',
            opponentType: 'STUDENT',
            content,
            createdAt: new Date()
          }
        }
      })

      await this.$apollo.mutate({
        mutation: UpdateConversation,
        variables: {
          input: {
            id: conversationId,
            userId: this.student.studentId,
            lastMessageId: messageResponce.data.createMessage.id,
            updatedAt: new Date()
          }
        }
      })

      await this.$apollo.mutate({
        mutation: UpdateConversation,
        variables: {
          input: {
            id: conversationId,
            userId: this.user.enterpriseId,
            lastMessageId: messageResponce.data.createMessage.id,
            updatedAt: new Date()
          }
        }
      })

      return messageResponce.data.createMessage.id
    },
    sendSlackHook (room, message) {
      let title = `[${this.env.STAGE}][企業]ルームを作成しました`
      let color = '#1e4573'

      const body = {
        attachments: [
          {
            fallback: title,
            color: color,
            fields: [
              {
                title: title,
                value: `ルームid: ${room.id}\n` +
                       `メッセージid: ${message.id}\n` +
                       `送信者: ${room.user.name}\n` +
                       `送信者id: ${room.user.id}\n` +
                       `受信者: ${room.opponent.name}\n` +
                       `受信者id: ${room.opponent.id}\n` +
                       `タイトル: ${room.title}\n` +
                       `内容: ${message.content}`
              }
            ]
          }
        ]
      }

      axios.post(slackUrl, JSON.stringify(body), { responseType: 'text' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/intern/scout/scout.js